import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Subject } from "rxjs";
import { delay, filter, take, takeUntil } from "rxjs/operators";

import { GCADAConfigService } from "@GCADA/services/config.service";
import { GCADAPerfectScrollbarDirective } from "@GCADA/directives/GCADA-perfect-scrollbar/GCADA-perfect-scrollbar.directive";
import { GCADANavigationService } from "@GCADA/components/navigation/navigation.service";
import { GCADASidebarService } from "@GCADA/components/sidebar/sidebar.service";

@Component({
  selector: "navbar-vertical-style-1",
  templateUrl: "./style-1.component.html",
  styleUrls: ["./style-1.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class NavbarVerticalStyle1Component implements OnInit, OnDestroy {
  //Inside the view
  public GCADAConfig: any;
  public userFullname: string;
  public userEmailaddress: string;

  // Private
  private _GCADAPerfectScrollbar: GCADAPerfectScrollbarDirective;
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {GCADAConfigService} GCADAConfigService
   * @param {GCADANavigationService} GCADANavigationService
   * @param {GCADASidebarService} GCADASidebarService
   * @param {Router} _router
   */
  constructor(
    private _GCADAConfigService: GCADAConfigService,
    private _GCADANavigationService: GCADANavigationService,
    private _GCADASidebarService: GCADASidebarService,
    private _router: Router,
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // Directive
  @ViewChild(GCADAPerfectScrollbarDirective, { static: true })
  set directive(theDirective: GCADAPerfectScrollbarDirective) {
    if (!theDirective) {
      return;
    }

    this._GCADAPerfectScrollbar = theDirective;

    // Update the scrollbar on collapsable item toggle
    this._GCADANavigationService.onItemCollapseToggled
      .pipe(delay(500), takeUntil(this._unsubscribeAll))
      .subscribe(() => {
        this._GCADAPerfectScrollbar.update();
      });
  }

  /**
   * On init
   */
  ngOnInit(): void {
    //Get user detail
    this.userFullname =
      localStorage.getItem("firstName") +
      " " +
      localStorage.getItem("lastName");
    this.userEmailaddress = localStorage.getItem("email");

    // Subscribe to the config changes
    this._GCADAConfigService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((config) => {
        this.GCADAConfig = config;
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  /**
   * Toggle sidebar opened status
   */
  toggleSidebarOpened(): void {
    this._GCADASidebarService.getSidebar("navbar").toggleOpen();
  }

  /**
   * Toggle sidebar folded status
   */
  toggleSidebarFolded(): void {
    this._GCADASidebarService.getSidebar("navbar").toggleFold();
  }

  goHome() {
    this._router.navigate(["/pages/home"]);
  }
}
